import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { errorText } from '../i18n';
import { api, ApiError } from '../net/api';
import { useSession } from '../stores/session';
import { Button, Spinner } from '../ui/Button';
import s from '../ui/ui.module.css';

export function NameEntry() {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [inUse, setInUse] = useState(false);

  async function submit(takeover = false) {
    setBusy(true);
    setError(null);
    try {
      const res = await api.createSession(name, takeover);
      useSession.getState().setAuth(res.token, res.user);
    } catch (e) {
      const code = e instanceof ApiError ? e.code : 'NETWORK';
      if (code === 'NAME_IN_USE') setInUse(true);
      setError(code === 'NAME_IN_USE' ? t('name.inUse', { name }) : errorText(code));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        void submit(false);
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
    >
      <label className={s.field}>
        <span className={s.label}>{t('name.label')}</span>
        <input
          className={s.input}
          autoFocus
          maxLength={20}
          value={name}
          placeholder={t('name.placeholder')}
          onChange={(e) => {
            setName(e.target.value);
            setInUse(false);
            setError(null);
          }}
          data-testid="name-input"
        />
      </label>
      <Button type="submit" variant="primary" size="large" disabled={busy || name.trim().length < 2} data-testid="name-submit">
        {busy ? <Spinner /> : null} {t('name.enter')}
      </Button>
      {error ? <div style={{ color: 'var(--danger)', fontSize: 14 }}>{error}</div> : null}
      {inUse ? (
        <Button variant="secondary" onClick={() => void submit(true)} disabled={busy}>
          {t('name.takeover')}
        </Button>
      ) : null}
      <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>{t('name.hint')}</p>
    </form>
  );
}
